import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStatus } from '../../hooks/useAuthStatus';

const PublicRoute = ({ children }) => {
  const { loggedIn, checkingStatus } = useAuthStatus();
  const location = useLocation();

  if (checkingStatus) {
    return <div>Loading...</div>;
  }

  if (loggedIn && location.pathname === '/sign-in') {
    return <Navigate to="/" />;
  }

  return children;
};

export default PublicRoute;